import React, { Suspense } from 'react';
import { Spinner } from "react-bootstrap";

import Belt from '../components/Belt';
import BeltLogged from '../components/BeltLogged';

import Footer from '../components/Footer';

const ConfirmPhoneForm = React.lazy(() => import('../forms/ConfirmPhoneForm'));

class ConfirmPhonePage extends React.Component {

  state = {

    data: [],
    newsCount: "",
    currentPage: "1",
    title: "RezerwujKort.pl - Profil"
  }

  componentDidMount() {

    document.title = "Potwierdzenie numeru telefonu - RezerwujKort.pl"
  }

  render() {

    var confirmPhone = <div>
      <Suspense fallback={<div>
        <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
      </div>}>
        <ConfirmPhoneForm />
      </Suspense>
    </div>

    return (

      <div>

        <Belt />

        <BeltLogged />

        {confirmPhone}

        <Footer />

      </div>
    );
  }
}
export default ConfirmPhonePage;
